/* eslint no-use-before-define: 0 */
/* tslint:disable */
const message = {
        "Sign in": "Sign in",
        "Welcome": "Welcome",
        "Upload sample": "Upload sample",
        "Loading...": "Loading...",
        "Step 1. Description": "Step 1. Description",
        "Add a project name and give instructions on your project.": "Add a project name and give instructions on your project.",
        "Step 2. Task": "Step 2. Task",
        "Select a type of the task for your project.": "Select a type of the task for your project.",
        "+ Add new class": "+ Add new class",
        "+ Add new entity": "+ Add new entity",
        "Each tag consists of a value. You can use tags to search and filter your resources.": "Each tag consists of a value. You can use tags to search and filter your resources.",
        "Step 5. Tags": "Step 5. Tags",
        "Tags": "Tags",
        "Name, tags ,task and class or entities required": "Name, tags ,task and class or entities required",
        "classification": "classification",
        "Class": "Class",
        "Statuses": "Status",
        "Entities": "Entities",
        "Select a “classification” type of the task in case you`d like to identify the “class” your images fall under.": "Select a “classification” type of the task in case you`d like to identify the “class” your images fall under.",
        "Select a “detection” type of the task in case you`d like to locate an object in an image with respect to the background. ": "Select a “detection” type of the task in case you`d like to locate an object in an image with respect to the background. ",
        "Classification": "Classification",
        "Task": "Task",
        "Operation update": "Operation update",
        "Description": "Description",
        "Enter your name": "Enter your name",
        "* Adding a project name is a required fiield. ": "* Adding a project name is a required fiield. ",
        "Name (*)": "Name (*)",
        "detection": "detection",
        "Detection": "Detection",
        "Object detection": "Object detection",
        "No Documents were found related to this request": "No Documents were found related to this request",
        "Color": "Color",
        "Name": "Name",
        "Type": "Type",
        "Add a name of the class and select the color of the element.": "Add a name of the class and select the color of the element.",
        "Add a name of the entity and select the color of the element.": "Add a name of the entity and select the color of the element.",
        "Create project": "Create project",
        "Upload please image png, svg+xml, jpeg, jpg types!": "Upload please image png, svg+xml, jpeg, jpg types!",
        "Name you entered already exist please try with different name!": "Name you entered already exist please try with different name!",
        "Please add name!": "Please add name!",
        "Confirm password required": "Confirm password required",
        "Confirm password": "Confirm password",
        "Computer Vision Enterprise AI": "Computer Vision Enterprise AI",
        "Passwords not matching": "Passwords not matching",
        "Step 2. Task": "Step 2. Task",
        "Step 3. Labeling data": "Step 3. Labeling data",
        "Step 4. Synthetic data": "Step 4. Synthetic data",
        "Step 5. Standardisation": "Step 5. Standardisation",
        "Step 6. Capacity management": "Step 6. Capacity management",
        "Step 7. Tags": "Step 7. Tags",
        "Step 8. Preview": "Step 8. Preview",
        "View your datset details.": "View your datset details.",
        "Manage capacity of machine for your dataset": "Manage capacity of machine for your dataset",
        "Standardisation feature allow to harmonize entities name and class name, avoid duplicate entities or class name or remove some elements you do not need for training.": "Standardisation feature allow to harmonize entities name and class name, avoid duplicate entities or class name or remove some elements you do not need for training.",
        "Select your generated data.": "Select your generated data.",
        "Select your labelling data.": "Select your labelling data.",
        "Type of dataset": "Type of dataset",
        "Labeling data": "Labeling data",
        "Synthetic data": "Synthetic data",
        "Standardisation": "Standardisation",
        "Capacity management": "Capacity management",
        "Preview": "Preview",
        "already exist": "already exist",
        "Organiser vos traitements par status afin de créer plus de profondeur dans l'analyse de vos données.": "Organize your processing by status in order to create more depth in the analysis of your data.",
        "Exemple de status: En cours, À corriger, Dossier incomplet, Approuvé": "Example of status: In progress, To be corrected, Incomplete file, Approved",
        "We recommend that you do use a small machine if your dataset contains only real data.": "We recommend that you do use a small machine if your dataset contains only real data.",
        "Its not possible to update this information during data processing": "Its not possible to update this information during data processing",
        "Machine 4 GiB memory size for small dataset without synthetic data on 4 workers": "Machine 4 GiB memory size for small dataset without synthetic data on 4 workers",
        "Machine 8 GiB memory size for medium dataset with synthetic data on 8 workers": "Machine 8 GiB memory size for medium dataset with synthetic data on 8 workers",
        "Machine 16 GiB memory size for big dataset with major part synthetic data on 16 workers": "Machine 16 GiB memory size for big dataset with major part synthetic data on 16 workers",

        "Attacher une API et un type d'export de données par défaut sur cet espace de travail.": "Attach an API and a default data export type on this company.",
        "Organiser vos traitements par status afin suivre dans le temps évolution de vos données.": "Organize your processing by status in order to follow the evolution of your data over time.",
        "Organiser vos traitements par catégorie afin de créer des segments dans l'analyse de vos données.": "Organize your treatments by category in order to create segments in the analysis of your data.",
        "Les priorités permettent de saisir les dossiers ou traitements les plus urgents à faire en premier.": "Priorities allow you to enter the most urgent files or treatments to be done first.",
        "Ajouter des points de contrôle dans vos traitements afin de ne rien oublier dans l'analyse de vos dossiers sur les éléments importants.": "Add control points in your processing so that you don't forget anything in the analysis of your files on the important elements.",
        "Ajouter l'option commentaire dans vos traitements afin communiquer avec vos clients, votre team en interne ou avec Wikibank!": "Add the comment option in your processing to communicate with your customers, your internal team or with Wikibank!",
        "Configurer un email entrant afin de recevoir des traitements sur cet espace de travail directement depuis votre boîte de réception Gmail ou Outlook.": "Configure an incoming email to receive treatments on this company directly from your Gmail or Outlook inbox.",
        "Définir une durée de retention des données selon votre organisation.": "Define a data retention period according to your organization.",
        "Exemple de catégorie: Produit 1, Catalogue 1, 2 ou Type 1 et 2": "Example of category: Product 1, Catalog 1, 2 or Type 1 and 2",

        "Small": "Small",
        "Medium": "Medium",
        "Large": "Large",
        "Machine capacity for your dataset.": "Machine capacity for your dataset.",
        "Machine size": "Machine size",
        "Server execution time for your dataset processing.": "Server execution time for your dataset processing.",
        "Timeout": "Timeout",
        "+ add field for rename or skip": "+ add field for rename or skip",
        "Add field": "Add field",
        "new key": "new key",
        "key": "key",
        "+ Add Scene": "+ Add Scene",
        "Select Scene": "Select Scene",
        "Scenes": "Scenes",
        "* Specify the total number of images you expect for generation.": "* Specify the total number of images you expect for generation.",
        "Total images": "Total images",
        "If you plan to use only synthetic data for this dataset, we advise you to set 20% for test rate and if you plan to create dataset with both synthetic data and labelling data we advise you to set 20% or 0% for test rate.": "If you plan to use only synthetic data for this dataset, we advise you to set 20% for test rate and if you plan to create dataset with both synthetic data and labelling data we advise you to set 20% or 0% for test rate.",
        "* Indicate the number of images for testing.": "* Indicate the number of images for testing.",
        "Test rate percentage (%)": "Test rate percentage (%)",
        "Enter your count": "Enter your count",
        "Data annotated without unvalidated": "Data annotated without unvalidated",
        "Data annotated and validated": "Data annotated and validated",
        "Data annotated": "Data annotated",
        "Apply filter on your dataset": "Apply filter on your dataset",
        "Activate option croping for table document": "Activate option croping for table document",
        "Table dataset": "Table dataset",
        "Remove duplicate images on your dataset": "Remove duplicate images on your dataset",
        "Remove duplicate": "Remove duplicate",
        "We estimate the total labelling is arround": "We estimate the total labelling is arround",
        "+ Add labeling": "+ Add labeling",
        "Select Project": "Select Project",
        "Project labeling": "Project labeling",
        "* Indicate the quantity of data you expect on your dataset. 0 equal unlimit.": "* Indicate the quantity of data you expect on your dataset. 0 equal unlimit.",
        "Limitation": "Limitation",
        "If you plan to use only labelling data for this dataset, we advise you to set 20% for test rate and if you plan to create dataset with both synthetic data and labelling data we advise you to set 80% or 100% for test rate.": "If you plan to use only labelling data for this dataset, we advise you to set 20% for test rate and if you plan to create dataset with both synthetic data and labelling data we advise you to set 80% or 100% for test rate.",
        "Select a type of your dataset.": "Select a type of your dataset.",
        "💡 Each JSON file is linked with each image.": "💡 Each JSON file is linked with each image.",
        "For document classification or document extraction key-pairs values, you can prepare OCR text extraction to write in JSON files containing all texts blocks for pre-processing training model. 📝": "For document classification or document extraction key-pairs values, you can prepare OCR text extraction to write in JSON files containing all texts blocks for pre-processing training model. 📝",
        "OCR processing detection": "OCR processing detection",
        "OCR processing classification": "OCR processing classification",
        "Select a “detection” type in case you want to locate an object in an image with respect to the background.": "Select a “detection” type in case you want to locate an object in an image with respect to the background.",
        "Select a “classification” type in case you want to identify the “class’ your images fall under.": "Select a “classification” type in case you want to identify the “class’ your images fall under.",
        "Add a dataset name and an optional desription for your dataset.": "Add a dataset name and an optional desription for your dataset.",
        "* Adding a dataset name is a required field. ": "* Adding a dataset name is a required field. ",
        "labelClass": "labelClass",
        "Scenes are Failed to scane": "Scenes are Failed to scane",
        "Scenes are scanned successfully": "Scenes are scanned successfully",
        "Scanning :": "Scanning :",
        "Scane projects scene": "Scane projects scene",
        "Sorry, not able to generate your dataset. Please try again later or contact support.": "Sorry, not able to generate your dataset. Please try again later or contact support.",
        "Sorry, not able to generate your dataset. Please try again later.": "Sorry, not able to generate your dataset. Please try again later.",
        "Please select valid scene": "Please select valid scene",
        "is not valid scene please with different scene or fix this scene.": "is not valid scene please with different scene or fix this scene.",
        "Add a name and an optional description for your labelling data.": "Add a name and an optional description for your labelling data.",
        "Enter Description": "Enter Description",
        "Name and preset required": "Name and preset required",
        "Preset": "Preset",
        "Select data store": "Select data store",
        "Step 2. data store": "Step 2. data store",
        "Select preset data collection to start your labelling.": "Select preset data collection to start your labelling.",
        "sorry, thresh hold only can between 0 to 100": "sorry, thresh hold only can between 0 to 100",
        "All inputs need to be filled!": "All inputs need to be filled!",
        "* Adding a preset name is a required filed.": "* Adding a preset name is a required filed.",
        "Add a preset name and an optional description for your preset.": "Add a preset name and an optional description for your preset.",
        "Image pre-processingwith PNG, JPEG or PDF": "Image pre-processingwith PNG, JPEG or PDF",
        "Text pre-processing with CSV format": "Text pre-processing with CSV format",
        "Select a type of your preset.": "Select a type of your preset.",
        "Step 3. Tags": "Step 3. Tags",
        "Name and background required": "Name and background required",
        "Add your synthetic data name and an optional description for your data": "Add your synthetic data name and an optional description for your data",
        "Background": "Background",
        "Image": "Image",
        "Blank": "Blank",
        "Width": "Width",
        "Height": "Height",
        "Background color": "Background color",
        "Background image": "Background image",
        "Step 2. Background": "Step 2. Background",
        "Select a background for your scene. You can leave the background blank or you can upload an image which will be the background for your scene.": "Select a background for your scene. You can leave the background blank or you can upload an image which will be the background for your scene.",
        "Please image uploaded need be less than 1mb": "Please image uploaded need be less than 1mb",
        "Name, description of your dataset": "Name, description of your dataset",
        "Predicts all the correct tags you want to assign to an image": "Predicts all the correct tags you want to assign to an image",
        "Predicts all the locations of items that interest you": "Predicts all the locations of items that interest you",
        "Classify your dataset": "Classify your dataset",
        "Zip File": "Zip File",
        "Zip": "Zip",
        "URL": "URL",
        "Upload file (ZIP Format)": "Upload file (ZIP Format)",
        "Upload zip file": "Upload zip file",
        "Please, you need to use compatible dataset in zip file. Please follow our documentation for compatibility on classification and detection": "Please, you need to use compatible dataset in zip file. Please follow our documentation for compatibility on classification and detection",
        "Add your URL": "Add your URL",
        "Enter your URL": "Enter your URL",
        "Step 3. Zip File": "Step 3. Zip File",
        "Upload already existing dataset": "Upload already existing dataset",
        "View your model details and create the model.": "View your model details and create the model.",
        "It may take 2-15 minutes to start the training": "It may take 2-15 minutes to start the training",
        "- Capacty machine 16 or 32 GiB memory, NVIDIA T4 Tensor Core (16 GiB GPU memory)": "- Capacty machine 16 or 32 GiB memory, NVIDIA T4 Tensor Core (16 GiB GPU memory)",
        "- Capacty machine 64 GiB memory, NVIDIA T4 Tensor Core (16 GiB GPU memory)": "- Capacty machine 64 GiB memory, NVIDIA T4 Tensor Core (16 GiB GPU memory)",
        "- Capacty machine 61 GiB memory, Faster GPU NVIDIA V100 (16 GiB GPU memory)": "- Capacty machine 61 GiB memory, Faster GPU NVIDIA V100 (16 GiB GPU memory)",
        "Its not possible to update this information during training": "Its not possible to update this information during training",
        "We recommend that you do use a small machine if your train GNN task or for proof of concept model": "We recommend that you do use a small machine if your train GNN task or for proof of concept model",
        "Machine capacity for model.": "Machine capacity for model.",
        "Server execution time for training model runtime.": "Server execution time for training model runtime.",
        "Manage capacity of machine for your model": "Manage capacity of machine for your model",
        "Initialize the pre-trained model from the previous model": "Initialize the pre-trained model from the previous model",
        "Transfer learning": "Transfer learning",
        "Only trains models successfull with checkpoints": "Only trains models successfull with checkpoints",
        "Select Train Epoch": "Select Train Epoch",
        "Checkpoint": "Checkpoint",
        "Select Model": "Select Model",
        "Train Model": "Train Model",
        "Step 5. Transfer learning": "Step 5. Transfer learning",
        "Specify a task, a number of epoches, a learning rate and a batch size of your model.": "Specify a task, a number of epoches, a learning rate and a batch size of your model.",
        "Specify your model and its training data, hyperparametres, data augmentation and evaluation metrics.": "Specify your model and its training data, hyperparametres, data augmentation and evaluation metrics.",
        "Configuration": "Configuration",
        "Metrics": "Metrics",
        "Metrics  - they are numeric values used to evaluate the performance of the models. There are classification metrics (accuracy, precision, recall, etc.), regression metrics (MSE, MAE), ranking metrics (MRR, DCG, NDCG), and statistical metrics.": "Metrics  - they are numeric values used to evaluate the performance of the models. There are classification metrics (accuracy, precision, recall, etc.), regression metrics (MSE, MAE), ranking metrics (MRR, DCG, NDCG), and statistical metrics.",
        "Data augmantation": "Data augmantation",
        "Data augmentation - is an image augmentation that turns out to be the result of geometric transformations, flipping, colour modification, cropping, rotation and random erasing.": "Data augmentation - is an image augmentation that turns out to be the result of geometric transformations, flipping, colour modification, cropping, rotation and random erasing.",
        "Hyperparametres": "Hyperparametres",
        "Hyperparametres - are parametres whose values are used to control the learning process.": "Hyperparametres - are parametres whose values are used to control the learning process.",
        "Model": "Model",
        "Model - is a file that has been trained to recognise certain types of patterns.You train a model over a set of data, providing it an algorithm that it can use to reason over and learn from those data.": "Model - is a file that has been trained to recognise certain types of patterns.You train a model over a set of data, providing it an algorithm that it can use to reason over and learn from those data.",
        "+ Add": "+ Add",
        "+ Add config": "+ Add config",
        "Batch size :": "Batch size :",
        "epoch must be between 50 to 200.": "epoch must be between 50 to 200.",
        "Lr must be less than or equal to 1.": "Lr must be less than or equal to 1.",
        "*Optimize with learning rate": "*Optimize with learning rate",
        "Learning Rate :": "Learning Rate :",
        "Number": "Number",
        "*Specify the number of epochs for  your model.": "*Specify the number of epochs for  your model.",
        "Number of epochs": "Number of epochs",
        "Model :": "Model :",
        "Task :": "Task :",
        "Expert": "Expert",
        "Basic": "Basic",
        "Step 4. Configuration": "Step 4. Configuration",
        "Dataset": "Dataset",
        "Select one of the datasets for your model.": "Select one of the datasets for your model.",
        "Author :": "Author :",
        "Date created :": "Date created :",
        "Download the logs": "Download the logs",
        "Logs :": "Logs :",
        "Dataset URL :": "Dataset URL :",
        "Dataset created automatically (100)": "Dataset created automatically (100)",
        "State :": "State :",
        "Status :": "Status :",
        "Total images :": "Total images :",
        "Task type :": "Task type :",
        "Tags :": "Tags :",
        "Description:": "Description:",
        "Name:": "Name:",
        "Dataset*": "Dataset*",
        "Step 3. Dataset": "Step 3. Dataset",
        "Add a model name and an optional description for your model.": "Add a model name and an optional description for your model.",
        "view the image before testing the model.": "view the image before testing the model.",
        "Upload preview image": "Upload preview image",
        "Step 2. Description": "Step 2. Description",
        "Select a type of the task.": "Select a type of the task.",
        "Step 1. Template": "Step 1. Template",
        "+ Use template": "+ Use template",
        "Classifies the documents basing both on the text and on the image.": "Classifies the documents basing both on the text and on the image.",
        "Classifies the documents basing on the text.": "Classifies the documents basing on the text.",
        "Analyzes the image and identifies the “class” the image falls under.": "Analyzes the image and identifies the “class” the image falls under.",
        "Locates interesting objects in an image with respect to the background.": "Locates interesting objects in an image with respect to the background.",
        "Estimates the number of object instances in a single image...": "Estimates the number of object instances in a single image...",
        "Detects the predefined keys and values correspondingly.": "Detects the predefined keys and values correspondingly.",
        "Keys-pairs value detection": "Keys-pairs value detection",
        "Document classification (text and image)": "Document classification (text and image)",
        "Document classification (text only)": "Document classification (text only)",
        "Image classification": "Image classification",
        "Object counting": "Object counting",
        "Sorry, not able to train model. Please try again later.": "Sorry, not able to train model. Please try again later.",
        "Train created successfully!": "Train created successfully!",
        "Sorry, not able to train model error on validation configuration. Please try again later or contact Wikibank.": "Sorry, not able to train model error on validation configuration. Please try again later or contact Wikibank.",
        "Configuration file is not valid": "Configuration file is not valid",
        "Sorry, Yaml is not valid. Please try again later or contact Wikibank.": "Sorry, Yaml is not valid. Please try again later or contact Wikibank.",
        "Search by name": "Search by name",
        "selected": "selected",
        "Diselect All": "Diselect All",
        "Delete": "Delete",
        "Item(s)": "Item(s)",
        "No Data Found": "No Data Found",
        "No data available": "No data available",
        "Show 30": "Show 30",
        "Show 50": "Show 50",
        "Show 100": "Show 100",
        "Copy": "Copy",
        "Transfer": "Transfer",
        "Download": "Download",
        "Import a images": "Import a images",
        "Import a files": "Import a files",
        "Delete similar file": "Delete similar file",
        "Delete duplicate file": "Delete duplicate file",
        "Export sample": "Export sample",
        "Drop .csv, .txt files to upload": "Drop .csv, .txt files to upload",
        "Drop PNG or JPG files to upload": "Drop PNG or JPG files to upload",
        "Cancel": "Cancel",
        "Select Preset": "Select Preset",
        "Transfer To preset:": "Transfer To preset:",
        "Files:": "Files:",
        "Transfer Files": "Transfer Files",
        "Copy To preset:": "Copy To preset:",
        "Copy Files": "Copy Files",
        "Start": "Start",
        "From": "From",
        "Select your range page": "Select your range page",
        "Page": "Page",
        "Similar files": "Similar files",
        "To": "To",
        "Duplicate files": "Duplicate files",
        "Sorry, not able to process this task. Please try again later or contact Wikibank.": "Sorry, not able to process this task. Please try again later or contact Wikibank.",
        "Successfull task created": "Successfull task created",
        "Files transfered successfully": "Files transfered successfully",
        "Files copied successfully": "Files copied successfully",
        "image not created": "image not created",
        "error ocurred": "error ocurred",
        "uploaded successfully": "uploaded successfully",
        "not uploaded": "not uploaded",
        "Document not supported": "Document not supported",
        "You cannot undo this once performed.": "You cannot undo this once performed.",
        "Transfer preset to another company": "Transfer preset to another company",
        "Transfer all data": "Transfer all data",
        "Transfer all data to another preset": "Transfer all data to another preset",
        "Delete preset": "Delete preset",
        "Delete this preset": "Delete this preset",
        "Company:": "Company:",
        "Transfer preset": "Transfer preset",
        "error in transfer company": "error in transfer company",
        "Prest moved to": "Prest moved to",
        "successfully": "successfully",
        "Preset transfered successfully": "Preset transfered successfully",
        "updated successfully": "updated successfully",
        "No data found": "No data found",
        "Data store(s)": "Data store(s)",
        "item(s)": "item(s)",
        "submit": "submit",
        "Upload a zip": "Upload a zip",
        "Import Classification": "Import Classification",
        "Enter Name": "Enter Name",
        "Change status": "Change status",
        "Select status": "Select status",
        "Status changed successfully!": "Status changed successfully!",
        "Classes": "Classes",
        "Labeled": "Labeled",
        "Generated": "Generated",
        "Meta information": "Meta information",
        "Type of task": "Type of task",
        "Objects": "Objects",
        "Total labeling": "Total labeling",
        "Total scenes": "Total scenes",
        "Workers": "Workers",
        "Sample": "Sample",
        "Show 10": "Show 10",
        "Scene for classifications are not available": "Scene for classifications are not available",
        "No scene avilable": "No scene avilable",
        "Grid": "Grid",
        "Delete this project": "Delete this project",
        "Deleting a project will also delete all the labellings and scenes that have been submitted to a project.": "Deleting a project will also delete all the labellings and scenes that have been submitted to a project.",
        "Delete project": "Delete project",
        "Transfer Project to another company": "Transfer Project to another company",
        "Transfer project": "Transfer project",
        "Select company": "Select company",
        "Project moved to": "Project moved to",
        "Change sample": "Change sample",
        "Please upload image!": "Please upload image!",
        "Instruction": "Instruction",
        "Total labelling": "Total labelling",
        "Scene(s)": "Scene(s)",
        "Project(s)": "Project(s)",
        "Heatmaps are not available for Classification": "Heatmaps are not available for Classification",
        "Page not have heatmaps": "Page not have heatmaps",
        "Test": "Test",
        "Train": "Train",
        "Object Distribution": "Object Distribution",
        "Image Size Distribution": "Image Size Distribution",
        "Annotations Per Image": "Annotations Per Image",
        "Page not have analytics": "Page not have analytics",
        "Update Dataset": "Update Dataset",
        "Transfer Dataset": "Transfer Dataset",
        "error in update dataset": "error in update dataset",
        "dataset updated successfully": "dataset updated successfully",
        "Dataset moved to": "Dataset moved to",
        "Export results": "Export results",
        "Sorry, not able to export your documents. Please try again later or contact support.": "Sorry, not able to export your documents. Please try again later or contact support.",
        "Documents exported successfully": "Documents exported successfully",
        "Change": "Change",
        "Select state": "Select state",
        "Select catagory": "Select catagory",
        "category change sucessfully!": "category change sucessfully!",
        "state change sucessfully!": "state change sucessfully!",
        "status change sucessfully!": "status change sucessfully!",
        "This request is under processing. Please wait when is processed 📝": "This request is under processing. Please wait when is processed 📝",
        "Oops, this request is not compatible with new version. Please try to submit new request or contact support. 🗒": "Oops, this request is not compatible with new version. Please try to submit new request or contact support. 🗒",
        "1. Request information": "1. Request information",
        "Path:": "Path:",
        "Request ID:": "Request ID:",
        "Task ID:": "Task ID:",
        "Account name:": "Account name:",
        "State:": "State:",
        "Status:": "Status:",
        "Category:": "Category:",
        "Company": "Company",
        "Total documents:": "Total documents:",
        "Total pages:": "Total pages:",
        "Created at:": "Created at:",
        "Started at:": "Started at:",
        "Processed at:": "Processed at:",
        "Time processing:": "Time processing:",
        "Tags:": "Tags:",
        "Author:": "Author:",
        "2. Document List": "2. Document List",
        "Document": "Document",
        "Pages": "Pages",
        "Extension": "Extension",
        "+ Add Rows": "+ Add Rows",
        "Edit": "Edit",
        "+ Add class": "+ Add class",
        "+ Add entity": "+ Add entity",
        "Add row": "Add row",
        "Update row": "Update row",
        "Update class": "Update class",
        "Add class": "Add class",
        "Document name": "Document name",
        "Add entity": "Add entity",
        "Update entity": "Update entity",
        "Second value": "Second value",
        "Value": "Value",
        "Select page": "Select page",
        "Select Class": "Select Class",
        "value2": "value2",
        "value": "value",
        "Select entity": "Select entity",
        "Exports(s)": "Exports(s)",
        "Request(s)": "Request(s)",
        "change state": "change state",
        "change category": "change category",
        "Export result": "Export result",
        "Low confidence": "Low confidence",
        "Active learning": "Active learning",
        "All": "All",
        "1 day": "1 day",
        "1 week": "1 week",
        "1 month": "1 month",
        "3 months": "3 months",
        "Submit a request": "Submit a request",
        "You can organize your work by status and categories.": "You can organize your work by status and categories.",
        "Add category or status": "Add category or status",
        "See all categories": "See all categories",
        "Categories": "Categories",
        "See all status": "See all status",
        "Status": "Status",
        "Step 1. Documents": "Step 1. Documents",
        "Documents": "Documents",
        "Import your documents for processing by Wikibank Platform.": "Import your documents for processing by Wikibank Platform.",
        "Step 2. Path": "Step 2. Path",
        "API": "API",
        "Configure your API.": "Configure your API.",
        " Step 3. Tags": " Step 3. Tags",
        "Step 4. Preview": "Step 4. Preview",
        "Preview your import details before processing.": "Preview your import details before processing.",
        "Receive notification email": "Receive notification email",
        "Select an export type": "Select an export type",
        "List export types": "List export types",
        "List catagory": "List catagory",
        "Select a category": "Select a category",
        "List of APIs available on marketplace pre-trained": "List of APIs available on marketplace pre-trained",
        "API Pretained model": "API Pretained model",
        "Select an API": "Select an API",
        "Wikibank currently supports PNG, JPEG, and PDF formats.": "Wikibank currently supports PNG, JPEG, and PDF formats.",
        "Image files sent to the Wikibank API should not exceed 100 MB (4 MB for the free tier).": "Image files sent to the Wikibank API should not exceed 100 MB (4 MB for the free tier).",
        "Reducing your file size can significantly improve throughput; however, be careful not to reduce image quality in process": "Reducing your file size can significantly improve throughput; however, be careful not to reduce image quality in process",
        "Upload a document(s)": "Upload a document(s)",
        "Dashboard": "Dashboard",
        "Synthese": "Synthese",
        "Sorry, not able to submit document. Please try again later or contact support.": "Sorry, not able to submit document. Please try again later or contact support.",
        "Document submitted successfully": "Document submitted successfully",
        "Path is required field": "Path is required field",
        "This request is archived because over 2 weeks of retention data.": "This request is archived because over retention data time.",
        "Detail": "Detail",
        "Deleted": "Deleted",
        "Dataset(s)": "Dataset(s)",
        "You need contact Wikibank Team for upload datasets": "You need contact Wikibank Team for upload datasets",
        "You need contact Wikibank Team for generate datasets": "You need contact Wikibank Team for generate datasets",
        "Dataset generated successfully!": "Dataset generated successfully!",
        "Documentation": "Documentation",
        "Developer Guide": "Developer Guide",
        "API Reference": "API Reference",
        "Admin": "Admin",
        "Terms of use": "Terms of use",
        "Legal notice": "Legal notice",
        "GDPR": "GDPR",
        "Privacy policy": "Privacy policy",
        "© 2016-2023, Wikibank Platform, All rights reserved.": "© 2016-2023, Wikibank Platform, All rights reserved.",
        "View analytics for your requests": "View analytics for your requests",
        "Create API for make visible your models.": "Create API for make visible your models.",
        "Test your model and inference.": "Test your model and inference.",
        "Train the model with your data.": "Train the model with your data.",
        "Generate a dataset zip file for training.": "Generate a dataset zip file for training.",
        "Collect, prepare and clean out your data.": "Collect, prepare and clean out your data.",
        "Generate your synthetic data and label your real data.": "Generate your synthetic data and label your real data.",
        "View your inference API and deploy the model.": "View your inference API and deploy the model.",
        "Step 10. Preview": "Step 10. Preview",
        "Press": "Press",
        "ENTER": "ENTER",
        "for add new tag": "for add new tag",
        "ESC": "ESC",
        "to cancel": "to cancel",
        "Create a tag for your inference.": "Create a tag for your inference.",
        "Step 9. Tags": "Step 9. Tags",
        "Tables": "Tables",
        "Export": "Export",
        "Dashboard configuration.": "Dashboard configuration.",
        "Change edit document status, state": "Change edit document status, state",
        "Allow items :": "Allow items :",
        "Confidence": "Confidence",
        "Entity Name": "Entity Name",
        "Display items :": "Display items :",
        "We recommend that you do not use a large machine if you plan to deploy gnn or python inference task. 😃": "We recommend that you do not use a large machine if you plan to deploy gnn or python inference task. 😃",
        "Dashboard configuration": "Dashboard configuration",
        "Step 8. Dashboard configuration": "Step 8. Dashboard configuration",
        "It's not possible to update this information during inference processing ": "It's not possible to update this information during inference processing ",
        "- Machine 6 GiB memory size for GNN inference or python task": "- Machine 6 GiB memory size for GNN inference or python task",
        "- Machine 10 GiB memory size for computer vision task": "- Machine 10 GiB memory size for computer vision task",
        "- Machine 16 GiB memory size for big or complex model (complex or multiple models etc...)": "- Machine 16 GiB memory size for big or complex model (complex or multiple models etc...)",
        "Machine capacity for your inference.": "Machine capacity for your inference.",
        "Server execution time for inference processing.": "Server execution time for inference processing.",
        "All inferences running on CPU device": "All inferences running on CPU device",
        "Step 7. Capacity management": "Step 7. Capacity management",
        "Manage capacity of machine for your inference": "Manage capacity of machine for your inference",
        "Testing": "Testing",
        "Step 6. Testing": "Step 6. Testing",
        "Test your inference before deploying it.": "Test your inference before deploying it.",
        "Select Queue name": "Select Queue name",
        "Purge response": "Purge response",
        "Disable saved documents name": "Disable saved documents name",
        "Queue name": "Queue name",
        "Retension": "Retension",
        "Security": "Security",
        "Step 5. Security": "Step 5. Security",
        "Specify important security actions to protect your data": "Specify important security actions to protect your data",
        "Post-processing": "Post-processing",
        "Step 4. Post-processing": "Step 4. Post-processing",
        "Apply clean build-in functions to post-process your model.": "Apply clean build-in functions to post-process your model.",
        "Keep Best Entity": "Keep Best Entity",
        "keep_best_class": "keep_best_class",
        "Keep best class filtered by confidence value.": "Keep best class filtered by confidence value.",
        "group_entity_by_name": "group_entity_by_name",
        "Group bounding box and fixed issues value splited.": "Group bounding box and fixed issues value splited.",
        "group_horizontal_entity_by_name": "group_horizontal_entity_by_name",
        "Group horizontal bounding box and fixed issues value splited.": "Group horizontal bounding box and fixed issues value splited.",
        "keep_best_entity": "keep_best_entity",
        "Keep best entities filtered by confidence value.": "Keep best entities filtered by confidence value.",
        "remove_low_confidence": "remove_low_confidence",
        "Remove low confidence and keep only good element.": "Remove low confidence and keep only good element.",
        "rename": "rename",
        "Rename entities and class name.": "Rename entities and class name.",
        "add_type_list": "add_type_list",
        "Type entites object for user experience.": "Type entites object for user experience.",
        "text_cleaning": "text_cleaning",
        "Remove specials charaters and keep alphanumeric.": "Remove specials charaters and keep alphanumeric.",
        "replace_colors": "replace_colors",
        "Change color field on entity and class object.": "Change color field on entity and class object.",
        "Add model": "Add model",
        "Select Train": "Select Train",
        "Models": "Models",
        "Step 3. Models": "Step 3. Models",
        "Attach different models to your API.": "Attach different models to your API.",
        "Attach different models to your test.": "Attach different models to your test.",
        "Path (URL)": "Path (URL)",
        "Configurate your API route.": "Configurate your API route.",
        "Pretrained": "Pretrained",
        "Beta": "Beta",
        "Default image": "Default image",
        "Select language": "Select language",
        "Language": "Language",
        "Select Country": "Select Country",
        "Country": "Country",
        "Select Category": "Select Category",
        "Category": "Category",
        "Display Name": "Display Name",
        "*Adding an inference name is a required field.": "*Adding an inference name is a required field.",
        "Name and describe your inference.": "Name and describe your inference.",
        "Add Fields": "Add Fields",
        "Add fields from project": "Add fields from project",
        "All input fields need to field": "All input fields need to field",
        "Path you entered already exist, please try with another one.": "Path you entered already exist, please try with another one.",
        "*Each tag consists of a value. You can use tags to search and filter your resources.": "*Each tag consists of a value. You can use tags to search and filter your resources.",
        "Test your inference before deploy.": "Test your inference before deploy.",
        "Environnements variables": "Environnements variables",
        "Describe YML configuration to your inference": "Describe YML configuration to your inference",
        "Step 4. Environnements variables": "Step 4. Environnements variables",
        "Pass Splitting": "Pass Splitting",
        "Funtion name": "Funtion name",
        "Function": "Function",
        "Step 3. Function": "Step 3. Function",
        "Specify a post-processing function.": "Specify a post-processing function.",
        "Name required": "Name required",
        "Server execution time for your inference processing.": "Server execution time for your inference processing.",
        "- Machine 8 GiB memory size for big or complex model (like complex or multiple models etc...)": "- Machine 8 GiB memory size for big or complex model (like complex or multiple models etc...)",
        "- Machine 6 GiB memory size for computer vision task": "- Machine 6 GiB memory size for computer vision task",
        " - Machine 4 GiB memory size for GNN inference or python task": " - Machine 4 GiB memory size for GNN inference or python task",
        "💡 We recommend that you do use a small machine if you plan to deploy GNN or python inference task. 😃": "💡 We recommend that you do use a small machine if you plan to deploy GNN or python inference task. 😃",
        "Restore": "Restore",
        "Revision restored sucessfully!": "Revision restored sucessfully!",
        "an error has occured, Please try again or contact wikibank": "an error has occured, Please try again or contact wikibank",
        "Delete this inference": "Delete this inference",
        "Update inference": "Update inference",
        "Delete inference": "Delete inference",
        "Tag": "Tag",
        "Change default image": "Change default image",
        "Inference updated successfully": "Inference updated successfully",
        "error in update Model": "error in update Model",
        "API(s)": "API(s)",
        "Roll Back inference": "Roll Back inference",
        "Roll back version": "Roll back version",
        "Device Disk": "Device Disk",
        "Device Memory": "Device Memory",
        "Device CPU": "Device CPU",
        "12 hours": "12 hours",
        "3 days": "3 days",
        "Last year": "Last year",
        "CPU": "CPU",
        "Memory": "Memory",
        "Disk": "Disk",
        "GPU": "GPU",
        "1. description": "1. description",
        "Logs": "Logs",
        "Author": "Author",
        "Date created": "Date created",
        "3.tags": "3.tags",
        "List": "List",
        "2. Documents": "2. Documents",
        "Mail": "Mail",
        "category": "category",
        "1. Informations": "1. Informations",
        "It may take from 2 to 15 minutes for generate zip dataset": "It may take from 2 to 15 minutes for generate zip dataset",
        "1. details": "1. details",
        "Item": "Item",
        "OCR Processing": "OCR Processing",
        "Machine Capicity": "Machine Capicity",
        "2. Description": "2. Description",
        "4. Labelling data": "4. Labelling data",
        "Test rate": "Test rate",
        "Filter": "Filter",
        "Projects labeling": "Projects labeling",
        "5. Synthetic data": "5. Synthetic data",
        "3. standardisation ": "3. standardisation ",
        "No": "No",
        "New key": "New key",
        "3. Train dataset": "3. Train dataset",
        "Project": "Project",
        "Size": "Size",
        "Generation": "Generation",
        "Labelling": "Labelling",
        "4. Test dataset": "4. Test dataset",
        "Task type": "Task type",
        "State": "State",
        "Dataset URL": "Dataset URL",
        "filtered Dataset": "filtered Dataset",
        "Annotated images": "Annotated images",
        "Annotated and validated images": "Annotated and validated images",
        "Annotated without unvalidated images": "Annotated without unvalidated images",
        "Labeling project(s)": "Labeling project(s)",
        "Knowledge Vision models": "Knowledge Vision models",
        "Total checkpoints": "Total checkpoints",
        "Label(s)": "Label(s)",
        "Labelings": "Labelings",
        "Created at": "Created at",
        "Train dataset": "Train dataset",
        "Test dataset": "Test dataset",
        "Function Name": "Function Name",
        "Version": "Version",
        "2. models": "2. models",
        "Number:": "Number:",
        "category": "Category",
        "state": "State",
        "status": "Status",
        "Display": "Display",
        "Historic Data": "Historic Data",
        "Add new comment": "Add new comment",
        "New Comment": "New Comment",
        "Loading comments": "Loading comments",
        "Dashboard Configuration": "Dashboard Configuration",
        "Display Items": "Display Items",
        "Disable saving documents name": "Disable saving documents name",
        "Delete file after processing": "Delete file after processing",
        "Disable saving response result": "Disable saving response result",
        "Datasets": "Datasets",
        "threshold": "threshold",
        "Project Labeling": "Project Labeling",
        "models": "models",
        "Template": "Template",
        "Configuration (Expert mode)": "Configuration (Expert mode)",
        "configuration (Basic mode)": "configuration (Basic mode)",
        "Batch": "Batch",
        "Epoch": "Epoch",
        "Learning Rate": "Learning Rate",
        "Checkpoints": "Checkpoints",
        "Simple-mode Details": "Simple-mode Details",
        "inference": "inference",
        "Labelling project(s)": "Labelling project(s)",
        "Copy Configuration": "Copy Configuration",
        "Download the configuration file": "Download the configuration file",
        "Configuration file": "Configuration file",
        "Members": "Members",
        "color": "color",
        "export Type": "export Type",
        "Steps items": "Steps items",
        "Step 3. Preview": "Step 3. Preview",
        "Preview all the details before creating your company": "Preview all the details before creating your company",
        "Specify categories and status": "Specify categories and status",
        "Step 3. Dashboard": "Step 3. Dashboard",
        "Add members to company.": "Add members to company.",
        "Step 2. Members": "Step 2. Members",
        "Name, describe and choose the symbol for company": "Name, describe and choose the symbol for company",
        "Add export type": "Add export type",
        "Export type": "Export type",
        "Add Category": "Add Category",
        "Add Status": "Add Status",
        "Select user": "Select user",
        "Data store": "Data store",
        "Analytics": "Analytics",
        "Upload the image in JPG or PNG format": "Upload the image in JPG or PNG format",
        "Logo": "Logo",
        "Enter your task": "Enter your task",
        "Enter your Description": "Enter your Description",
        "Please select color for your company": "Please select color for your company",
        "Please upload image for your company!": "Please upload image for your company!",
        "Please add task name!": "Please add task name!",
        "Please add description!": "Please add description!",
        "Retension Data": "Retension Data",
        "Update company": "Update company",
        "Send your documents from email inbox for appling documents processing directly without leave your inbox": "Send your documents from email inbox for appling documents processing directly without leave your inbox",
        "List of people can send email on this dashboard": "List of people can send email on this dashboard",
        "Email inbound": "Email inbound",
        "putNewPasswordBegin":"Enter your password",
        "putNewPassword":"Enter your new password",
        "Inbound email Configuration": "Inbound email Configuration",
        "API Configuration": "API Configuration",
        "Select a user": "Select a user",
        "Task *": "Task *",
        "Description *": "Description *",
        "Name *": "Name *",
        "Add members!": "Add members!",
        "Select image or color!": "Select image or color!",
        "My custom models": "My custom models",
        "Ask for train my custom models x10 faster with Wikibank Platform": "Ask for train my custom models x10 faster with Wikibank Platform",
        "AI Marketplace": "AI Marketplace",
        "Discover all pre-trained models available on Wikibank Platform": "Discover all pre-trained models available on Wikibank Platform",
        "members": "members",
        "Date": "Date",
        "Create new company for organize your better workflow": "Create new company for organize your better workflow",
        "Create new company": "Create new company",
        "Hello 👋, you are not currently in any company. Ask your administrator to add you to a company to start your experience with Wikibank Platform 🚀": "Hello 👋, you are not currently in any company. Ask your administrator to add you to a company to start your experience with Wikibank Platform 🚀",
        "Your account was suspended because of unpaid suscription. After payment, your account will be restored.": "Your account was suspended because of unpaid suscription. After payment, your account will be restored.",
        "Your account is expired, please contact sales team for review your account.": "Your account is expired, please contact sales team for review your account.",
        "Your account expire soon in": "Your account expire soon in",
        "days, please contact sales team for review your account. 🚀": "days, please contact sales team for review your account. 🚀",
        "Welcome to the Wikibank platform, your account must be verified by the sales team and we will contact you for more details.": "Welcome to the Wikibank platform, your account must be verified by the sales team and we will contact you for more details.",
        "Welcome to Wikibank Platform 🚀🚀": "Welcome to Wikibank Platform 🚀🚀",
        "Organise your workflow in one single place.": "Organise your workflow in one single place.",
        "Company deleted!": "Company deleted!",
        "Send": "Send",
        "Model(s)": "Model(s)",
        "You need contact Wikibank Team for train models": "You need contact Wikibank Team for train models",
        "Resume": "Resume",
        "Select checkpoints": "Select checkpoints",
        "Resume train": "Resume train",
        "Metrics not available": "Metrics not available",
        "The checkpoint(s)": "The checkpoint(s)",
        "should be the best": "should be the best",
        "Chart": "Chart",
        "Table": "Table",
        "Val": "Val",
        "Max": "Max",
        "Min": "Min",
        "Evaluation": "Evaluation",
        "Download model": "Download model",
        "checkpoint(s)": "checkpoint(s)",
        "Download checkpoint": "Download checkpoint",
        "See advanced configuration": "See advanced configuration",
        "Configuration content": "Configuration content",
        "Page not have logs": "Page not have logs",
        "True label": "True label",
        "Predicted label": "Predicted label",
        "Confusion matrix not available": "Confusion matrix not available",
        "Absolute matrix": "Absolute matrix",
        "Relative matrix": "Relative matrix",
        "Disk Device": "Disk Device",
        "CPU Device": "CPU Device",
        "Device": "Device",
        "You should select small machine or increase your batch size for next similar training": "You should select small machine or increase your batch size for next similar training",
        "Update model": "Update model",
        "Company": "Company",
        "Transfer Train": "Transfer Train",
        "Train updated successfully": "Train updated successfully",
        "Train moved to": "Train moved to",
        "Account(s)": "Account(s)",
        "Loading inference account(s)": "Loading inference account(s)",
        "Metadata": "Metadata",
        "Time processing": "Time processing",
        "Processed at": "Processed at",
        "Started at": "Started at",
        "Total documents": "Total documents",
        "Account name": "Account name",
        "Task ID": "Task ID",
        "Request ID": "Request ID",
        "Request information": "Request information",
        "Extract french Liasse fiscale entites from documents 2033, 2050 2035": "Extract french Liasse fiscale entites from documents 2033, 2050 2035",
        "Train your model with your data (either personal or generated by datalabs) and visualize the result": "Train your model with your data (either personal or generated by datalabs) and visualize the result",
        "Analyze your inference request on production": "Analyze your inference request on production",
        "Use our models for data detection, extraction, analysis and classification.": "Use our models for data detection, extraction, analysis and classification.",
        "see more": "see more",
        "Project Labelling": "Project Labelling",
        "View your testing API and deploy the model.": "View your testing API and deploy the model.",
        "Create a tag for your testing.": "Create a tag for your testing.",
        "Step 8. Tags": "Step 8. Tags",
        "Launch test": "Launch test",
        "Machine capacity for your testing.": "Machine capacity for your testing.",
        "Server execution time for testing processing.": "Server execution time for testing processing.",
        "Manage capacity of machine for your testing": "Manage capacity of machine for your testing",
        "Threshold must be between 0 to 100 ": "Threshold must be between 0 to 100 ",
        "limitation must be between 0 to 100000 ": "limitation must be between 0 to 100000 ",
        "Step 2. Configuration": "Step 2. Configuration",
        "Configurate task type for testing model.": "Configurate task type for testing model.",
        "Threshold": "Threshold",
        "Name and describe your testing.": "Name and describe your testing.",
        "No Results were found": "No Results were found",
        "ClassList": "ClassList",
        "OriginalImage": "OriginalImage",
        "Url": "Url",
        "Testing(s)": "Testing(s)",
        "Delete Testing": "Delete Testing",
        "Update Testing": "Update Testing",
        "Delete this testing": "Delete this testing",
        "testing updated successfully": "testing updated successfully",
        "Category(s)": "Category(s)",
        "category not found.": "category not found.",
        "Auto labelling is disable because it's already in progress.": "Auto labelling is disable because it's already in progress.",
        "Start auto-labelling": "Start auto-labelling",
        "Add limit": "Add limit",
        "Limit": "Limit",
        "Add threshold": "Add threshold",
        "Auto Labelling": "Auto Labelling",
        "Train Epoch": "Train Epoch",
        "Auto labelling submitted sucessfully.": "Auto labelling submitted sucessfully.",
        "Search by account name": "Search by account name",
        "Search by status": "Search by status",
        "Search by category": "Search by category",
        "Search by path": "Search by path",
        "Font size": "Font size",
        "Please select font family": "Please select font family",
        "Font family": "Font family",
        "Background Color": "Background Color",
        "+ Add source": "+ Add source",
        "Please select preset": "Please select preset",
        "Source(s)": "Source(s)",
        "H max": "H max",
        "H min": "H min",
        "W max": "W max",
        "W min": "W min",
        "Y min": "Y min",
        "X min": "X min",
        "Position": "Position",
        "Text": "Text",
        "Please select project and scenes": "Please select project and scenes",
        "Source": "Source",
        "Font": "Font",
        "No data avialable": "No data avialable",
        "Class Name": "Class Name",
        "Best class": "Best class",
        "SearchNumber": "SearchNumber",
        "Search": "Search",
        "Credit": "Credit",
        "Debit": "Debit",
        "Label": "Label",
        "Best entities": "Best entities",
        "No Document were found related to this request": "No Document were found related to this request",
        "Upload a document": "Upload a document",
        "Select by user": "Select by user",
        "Select by time": "Select by time",
        "Select by status": "Select by status",
        "The analytics page shows the number of the labelled images and the number of hours spent on the process": "The analytics page shows the number of the labelled images and the number of hours spent on the process",
        "Show additional Comments": "Show additional Comments",
        "Comments": "Comments",
        "Save": "Save",
        "Enter name": "Enter name",
        "Enter description": "Enter description",
        "Settings saved successfully!": "Settings saved successfully!",
        "Disapprove label": "Disapprove label",
        "Approve label": "Approve label",
        "Unskip label": "Unskip label",
        "Skip label": "Skip label",
        "Jump to next page": "Jump to next page",
        "Jump to previous page": "Jump to previous page",
        "Jump to next item": "Jump to next item",
        "Jump to previous item": "Jump to previous item",
        "GENERAL": "GENERAL",
        "VIEW CONTROLS": "VIEW CONTROLS",
        "Zoom in": "Zoom in",
        "Zoom out": "Zoom out",
        "or": "or",
        "Paste": "Paste",
        "Duplicate": "Duplicate",
        "Delete objects": "Delete objects",
        "OBJECTS": "OBJECTS",
        "TOOLS": "TOOLS",
        "Your account will be logout in": "Your account will be logout in",
        "Warning": "Warning",
        "Forgot password?": "Forgot password?",
        "Don't have an account?": "Don't have an account?",
        "© Copyright ": "© Copyright ",
        "Sign in with Microsoft": "Sign in with Microsoft",
        "Sign in with Google": "Sign in with Google",
        "to securely access your account with a new password.": "to securely access your account with a new password.",
        "If you like to sign in with this email, please use": "If you like to sign in with this email, please use",
        "Forgot password": "Forgot password",
        "Looks like you already have registered with Google account. Please use": "Looks like you already have registered with Google account. Please use",
        "Withdraw the recovery link": "Withdraw the recovery link",
        "We will email you a recovery link": "We will email you a recovery link",
        "Cannot connect?": "Cannot connect?",
        "Plateforme Cloud d automatisation": "Plateforme Cloud d automatisation",
        "Sorry, the maximum is 5 keys.": "Sorry, the maximum is 5 keys.",
        "Password successfull changed.": "Password successfull changed.",
        "New password and confirm new password not matching.": "New password and confirm new password not matching.",
        "Old password is incorrect.": "Old password is incorrect.",
        "Password not changed, please try later or contact support.": "Password not changed, please try later or contact support.",
        "Show": "Show",
        "Next": "Next",
        "Require password change at next login": "Require password change at next login",
        "Automatically generate password": "Automatically generate password",
        "Reset password for user": "Reset password for user",
        "Password edited!": "Password edited!",
        "Pretranied": "Pretranied",
        "Please enter a valid email": "Please enter a valid email",
        "Email": "Email",
        "Last name": "Last name",
        "user(s)": "user(s)",
        "Drop your files here": "Drop your files here",
        "In demo live, we will analyze only the": "In demo live, we will analyze only the",
        "first page": "first page",
        "of your document and we don't save your file during processing. Read more about our": "of your document and we don't save your file during processing. Read more about our",
        "Privacy Data Policy GDPR": "Privacy Data Policy GDPR",
        "Start a free trial": "Start a free trial",
        "Contact a sales team": "Contact a sales team",
        "radius": "radius",
        "Activate": "Activate",
        "Add blur to the image": "Add blur to the image",
        "Transforms the image into a 3 channels greyscale image": "Transforms the image into a 3 channels greyscale image",
        "Add basics folds to the image based of predefined folds images": "Add basics folds to the image based of predefined folds images",
        "Add a vintage effect to the documents": "Add a vintage effect to the documents",
        "upperValue": "upperValue",
        "lowerValue": "lowerValue",
        "Add salt and papper noise to the image": "Add salt and papper noise to the image",
        "Var": "Var",
        "Mean": "Mean",
        "(float > 0): the normalized mean of noise": "(float > 0): the normalized mean of noise",
        "The normalized variance of noise": "The normalized variance of noise",
        "Add gaussian noise to RGB channels independently": "Add gaussian noise to RGB channels independently",
        "Factor to create shading: 1 - black line along the fold, 0 - no change": "Factor to create shading: 1 - black line along the fold, 0 - no change",
        "Shade factor": "Shade factor",
        "Alpha": "Alpha",
        "Decay rate": "Decay rate",
        "(int > 0): decay for shading effect (number of pixels)": "(int > 0): decay for shading effect (number of pixels)",
        "Num folds": "Num folds",
        "(int > 0): the number of folds to be added to the image alpha (float [0-1]): weight factors to introduce deformations (better to take from 0.01 to 0.1)": "(int > 0): the number of folds to be added to the image alpha (float [0-1]): weight factors to introduce deformations (better to take from 0.01 to 0.1)",
        "Add 3D and shading": "Add 3D and shading",
        "(int): the number of iterations of the ink bleeding loop (WARNING: This degradation is really time consuming: use small values of iterations)": "(int): the number of iterations of the ink bleeding loop (WARNING: This degradation is really time consuming: use small values of iterations)",
        "Iterations": "Iterations",
        "(float [0-1]): weight of the verso pixel": "(float [0-1]): weight of the verso pixel",
        "Mirror the image, use it as a verso image and 'bleed' the ink into the recto": "Mirror the image, use it as a verso image and 'bleed' the ink into the recto",
        "Ink-bleeding": "Ink-bleeding",
        "Folds-3d": "Folds-3d",
        "Gaussian-noise": "Gaussian-noise",
        "Salt-and-papper": "Salt-and-papper",
        "Vintage": "Vintage",
        "Folds": "Folds",
        "Greyscale": "Greyscale",
        "Blur": "Blur",
        "Effects": "Effects",
        "File Not Uploaded. Upload File less Than 500 KB": "File Not Uploaded. Upload File less Than 500 KB",
        "Add new effect": "Add new effect",
        "Blur degradation": "Blur degradation",
        "Background URL": "Background URL",
        "Create new project": "Create new project",
        "Create new model": "Create new model",
        "Generate new dataset": "Generate new dataset",
        "Upload my own dataset": "Upload my own dataset",
        "Deploy an API": "Deploy an API",
        "Create new labelling": "Create new labelling",
        "Create new labeling": "Create new labeling",
        "Add new data store": "Add new data store",
        "Add User": "Add new user",
        "resetpassword": "Reset passport",
        "Create new Testing": "Create new Testing",
        "Create new scene": "Create new scene",
        "Compare": "Compare",
        "Preview image": "Preview image",
        "Testings": "Testings",
        "Load more requests": "Load more requests",
        "No datasets available": "No datasets available",
        "No keys available": "No keys available",
        "No Users available": "No Users available",
        "No inferences accounts available": "No inferences accounts available",
        "No requests available": "No requests available",
        "No export(s) available": "No export(s) available",
        "No data stores available": "No data stores available",
        "No projects available": "No projects available",
        "No label available": "No label available",
        "No scenes available": "No scenes available",
        "No inferences available": "No inferences available",
        "No revisions available": "No revisions available",
        "No labels available": "No labels available",
        "No category available": "No category available",
        "No Testings available": "No Testings available",
        "No models available": "No models available",
        "Train metrics no available": "Train metrics no available",
        "Test metrics no available": "Test metrics no available",
        "Evaluation metrics no available": "Evaluation metrics no available",
        "No info available": "No info available",
        "No config available": "No config available",
        "zoomin": "zoomin",
        "zoomout": "zoomout",
        "reset": "reset",
        "fit": "fit",
        "Object name": "Object name",
        "Unskip labelling": "Unskip labelling",
        "Skip labelling": "Skip labelling",
        "Copy link": "Copy link",
        "No histories found": "No histories found",
        "Id": "Id",
        "User": "User",
        "Submitted At": "Submitted At",
        "History": "History",
        "Deploy a remote API": "Deploy a remote API",
        "Create Labelling": "Create Labelling",
        "Submit": "Submit",
        "Create dataset": "Create dataset",
        "Create Preset": "Create Preset",
        "Create scene": "Create scene",
        "Update": "Update",
        "Deploy": "Deploy",
        "Create model": "Create model",
        "Create company": "Create company",
        "API key": "API key",
        "API secret": "API secret",
        "Last used": "Last used",
        "ops": "ops",
        "FaB": "FaB",
        "User name": "User name",
        "Email address": "Email address",
        "Last activity": "Last activity",
        "resetpassword": "resetpassword",
        "edit": "edit",
        "email": "email",
        "Plan-type": "Plan-type",
        "Request": "Request",
        "ID": "ID",
        "checkpoint": "checkpoint",
        "checkpoints": "checkpoints",
        "Path": "Path",
        "Time created": "Time created",
        "Time processed": "Time processed",
        "no project labelling": "no project labelling",
        "Duration": "Duration",
        "Import type": "Import type",
        "Images": "Images",
        "Operations": "Operations",
        "Elements": "Elements",
        "Labeling": "Labeling",
        "Total entities": "Total entities",
        "Images labeled": "Images labeled",
        "view": "view",
        "Created At": "Created At",
        "Approved": "Approved",
        "Date updated": "Date updated",
        "Default Image URL": "Default Image URL",
        "Inference Name": "Inference Name",
        "ProjectLabelling": "ProjectLabelling",
        "Coverage": "Coverage",
        "Time Processing": "Time Processing",
        "Training task": "Training task",
        "Training learner": "Training learner",
        "Nb epochs": "Nb epochs",
        "Batch size": "Batch size",
        "loss": "loss",
        "Model name": "Model name",
        "Backbone name": "Backbone name",
        "Pretrained fpn": "Pretrained fpn",
        "updatedAt": "updatedAt",
        "View scenes": "View scenes",
        "View labeling": "View labeling",
        "View": "View",
        "Queued": "Queued",
        "Started": "Started",
        "Uploaded": "Uploaded",
        "Running": "Running",
        "Doing": "Doing",
        "Finished": "Finished",
        "Processed": "Processed",
        "Failed": "Failed",
        "Failed System": "Failed System",
        "Canceled": "Canceled",
        "View all metrics": "View all metrics",
        "Re Run": "Re Run",
        "Manage": "Manage",
        "Update preset": "Update preset",
        "Settings": "Settings",
        "Make revision": "Make revision",
        "Roll back": "Roll back",
        "Accounting": "Accounting",
        "documents": "documents",
        "document": "document",
        "Overview": "Overview",
        "Users": "Users",
        "Confusion": "Confusion",
        "Errors": "Errors",
        "Confusion matrix": "Confusion matrix",
        "Data stores": "Data stores",
        "Projects": "Projects",
        "Results": "Results",
        "Data": "Data",
        "Heatmap": "Heatmap",
        "Built-in": "Built-in",
        "3.tags": "3.tags",
        "APIs": "APIs",
        "Editor": "Editor",
        "Archive": "Archive",
        "Email notification": "Email notification",
        "Document list": "Document list",
        "Heatmaps": "Heatmaps",
        "Response API": "Response API",
        "Introduction": "Introduction",
        "Revisions": "Revisions",
        "🤖 Tags can help AI to understand better your documents": "🤖 Tags can help AI to understand better your documents",
        "Monitor": "Monitor",
        "Requests": "Requests",
        "Live Testing": "Live Testing",
        "Accuracy": "Accuracy",
        "All images": "All images",
        "Unannotated images": "Unannotated images",
        "Skipped images": "Skipped images",
        "Approved images": "Approved images",
        "Disapproved images": "Disapproved images",
        "Account": "Account",
        "Accounts": "Accounts",
        "Knowledge Vision": "Knowledge Vision",
        "Inferencia": "Inferencia",
        "Auto labelling": "Auto labelling",
        "Compare metrics": "Compare metrics",
        "Next: API": "Next: API",
        "Next: Tags": "Next: Tags",
        "Next: Preview": "Next: Preview",
        "Prev: Documents": "Prev: Documents",
        "Prev: API": "Prev: API",
        "Prev: Tags": "Prev: Tags",
        "Next: Type of dataset": "Next: Type of dataset",
        "Next: Labelling data": "Next: Labelling data",
        "Next: Synthetic data": "Next: Synthetic data",
        "Next: Capacity management": "Next: Capacity management",
        "Prev: Description": "Prev: Description",
        "Prev: Type of dataset": "Prev: Type of dataset",
        "Prev: Labelling data": "Prev: Labelling data",
        "Prev: Synthetic data": "Prev: Synthetic data",
        "Prev: Capacity management": "Prev: Capacity management",
        "Next: Data store": "Next: Data store",
        "Next: Preset": "Next: Preset",
        "Next: Task": "Next: Task",
        "Prev: Task": "Prev: Task",
        "Next: Background": "Next: Background",
        "Next: Path": "Next: Path",
        "Next: Models": "Next: Models",
        "Next: Post-processing": "Next: Post-processing",
        "Next: Security": "Next: Security",
        "Next: Testing": "Next: Testing",
        "Next page": "Next page",
        "AI solution already approved by": "AI solution already approved by",
        "Prev page": "Prev page",
        "Download image": "Download image",
        "Prev: Path": "Prev: Path",
        "Prev: Models": "Prev: Models",
        "Prev: Post-processing": "Prev: Post-processing",
        "Prev: Security": "Prev: Security",
        "Prev: Testing": "Prev: Testing",
        "Next: Function": "Next: Function",
        "Next: Enviornment variables": "Next: Enviornment variables",
        "Next: Dashboard configuration": "Next: Dashboard configuration",
        "Prev: Function": "Prev: Function",
        "Prev: Enviornment variables": "Prev: Enviornment variables",
        "Prev: Dashboard configuration": "Prev: Dashboard configuration",
        "Next: Configuration": "Next: Configuration",
        "Prev: Configuration": "Prev: Configuration",
        "Next: Dataset": "Next: Dataset",
        "Next: Transfer learning": "Next: Transfer learning",
        "Prev: Template": "Prev: Template",
        "Prev: Dataset": "Prev: Dataset",
        "Prev: Transfer learning": "Prev: Transfer learning",
        "Next: Members": "Next: Members",
        "Prev: Members": "Prev: Members",
        "Oops...": "Oops...",
        "This page could not be found.": "This page could not be found.",
        "Loading Dataset": "Loading Dataset",
        "Loading data-stores": "Loading data-stores",
        "Loading items": "Loading items",
        "Loading confusion matrix": "Loading confusion matrix",
        "Loading metrics": "Loading metrics",
        "Loading companies": "Loading companies",
        "2 hours": "2 hours",
        "30 minutes": "30 minutes",
        "4 hours": "4 hours",
        "7 hour": "7 hour",
        "3 day": "3 day",
        "2 week": "2 week",
        "Create": "Create",
        "Playground": "Playground",
        "Please add": "Please add",
        "or select object": "or select object",
        "Already have an account?": "Already have an account?",
        "connexion": "connexion",
        "Resend confirmation email": "Resend confirmation email",
        "We have sent you a confirmation email. Please check it to finalize your registration.": "We have sent you a confirmation email. Please check it to finalize your registration.",
        "emailused": "Sorry, the email address you entered is already in use. Please enter a new one or log in if you already have an account.",
        "By signing up, I accept the": "By signing up, I accept the",
        "Terms and Conditions": "Terms and Conditions",
        "and": "and",
        "Privacy Policy": "Privacy Policy",
        "Email required.": "Email required.",
        "Last name too short": "Last name too short",
        "Last name too long": "Last name too long",
        "First name too long": "First name too long",
        "First name too short": "First name too short",
        "Sign up": "Sign up",
        "Password": "Password",
        "Try Wikibank Platform for free: no commitment, no credit card required.": "Try Wikibank Platform for free: no commitment, no credit card required.",
        "© Copyright": "© Copyright",
        "Sign up with Microsoft": "Sign up with Microsoft",
        "Sign up with Google": "Sign up with Google",
        "Confirmation email not sent, please try again.": "Confirmation email not sent, please try again.",
        "We will send a recovery link to your email": "We will send a recovery link to your email",
        "required": "required",
        "contactSupport": "contactSupport",
        "Send link": "Send link",
        "Oops, User not found!": "Oops, User not found!",
        "signup": "signup",
        "enterEmail": "enterEmail",
        "All companies": "All companies",
        "No logs available": "No logs available",
        "resultEmptyExtenxion": "resultEmptyExtenxion",
        "Profile": "Profile",
        "Change password": "Change password",
        "API Keys": "API Keys",
        "Old password": "Old password",
        "Confirm new password": "Confirm new password",
        "New password": "New password",
        "First name": "First name",
        "Confirm new password required.": "Confirm new password required.",
        "Old password required.": "Old password required.",
        "New password required.": "New password required.",
        "notificationType": "notificationType",
        "notificationURL": "notificationURL",
        "Retention": "Retention",
        "Add key": "Add key",
        "Update my company": "Update my company",
        "Update my profile": "Update my profile",
        "Company name": "Company name",
        "address": "address",
        "country": "country",
        "Update project": "Update project",
        "Loading analytics": "Loading analytics",
        "Loading model detail": "Loading model detail",
        "companies": "companies",
        "waitNetork": "Waiting for internet connection ...",
        "Home": "Home",
        "Analytics Item": "Analytics Item",
        "Table extraction": "Table extraction",
        "field": "field",
        'Auto checking submitted sucessfully.': 'Auto checking submitted sucessfully.',
        "Auto checking": "Auto checking",
        "Auto Checking": "Auto Checking",
        "Start auto-checking": "Start auto-checking",
        "Auto checking is disable because it's already in progress.": "Auto checking is disable because it's already in progress.",
        "Inferences Account": "Inferences Account",
        'choicePassword': 'choicePassword',
        'choiceNewPassword': 'choiceNewPassword',
        'Dashboard (beta)': 'Dashboard (beta)',
        'New Label': 'New Label',
        'New Scene': 'New Scene',
        'Upload Dataset': 'Upload Dataset',
        'newprocess': 'newprocess',
        'Datalabs': 'Datalabs',
        'Pacman - Playground': 'Pacman - Playground',
        'Matrix Train': 'Matrix Train',
        'New model': 'New model',
        'Inferences': 'Inferences',
        'Inference Account': 'Inference Account',
        'Inference': 'Inference',
        "Select a “classification” type in case you want to identify the “class’ your images fall under.": "Select a “classification” type in case you want to identify the “class’ your images fall under.",
        "Actions": "Actions",
        "JSON": "JSON",
        'Processing': 'Processing',
        "Loading image": "Loading image",
        'Loading API(s)': 'Loading API(s)',
        'Loading admin(s)': 'Loading admin(s)',
        "Loading": "Loading",
        'Loading Request(s)': 'Loading Request(s)',
        "Loading metrics": "Loading metrics",
        'Loading Heatmap': 'Loading Heatmap',
        "Scanning projects scenes": "Scanning projects scenes",
        'Loading projects': 'Loading projects',
        "Loading category": "Loading category",
        'Loading Testing(s)': 'Loading Testing(s)',
        'Loading model(s)': 'Loading model(s)',
        'Loading checkpoint metric(s)': 'Loading checkpoint metric(s)',
        'Loading checkpoint(s)': 'Loading checkpoint(s)',
        'Loading logs': 'Loading logs',
        'Loading monitor': 'Loading monitor',
        'loading': 'loading',
        'Annotated': 'Annotated',
        'Unannotated': 'Unannotated',
        'Skipped': 'Skipped',
        'Unapproved': 'Unapproved',
        'Approved': 'Approved',
        'Comments': 'Comments',
        'Auto-labelling': 'Auto-labelling',
        'Auto labelling': 'Auto labelling',
        'Auto checking': 'Auto checking',
        'Ready to use': 'Ready to use',
        'For demonstation': 'For demonstation',
        'haveAdminRole': 'haveAdminRole',
        "Auto Labeling": "Auto Labeling",
        'New Project': 'New Project',
        'New Data store': 'New Data store',
        'New Dataset': 'New Dataset',
        'New scene': 'New scene',
        'New Labelling': 'New Labelling',
        'New testing': 'New testing',
        'New company': 'New company',
        'New inference': 'New inference',
        'New inference account': 'New inference account',
        'Upload text file': 'Upload text file',
        'Upload image': 'Upload image',
        'Upload images': 'Upload images',
        "Upload file": "Upload file",
        "image": "image",
        "text": "text",
        '1_day': '1_day',
        '3_day': '3_day',
        '1_week': '1_week',
        '2_week': '2_week',
        '1_month': '1_month',
        '1_year': '1_year',
        '12_hours': '12_hours',
        "4 columns": "4 columns",
        "3 columns": "3 columns",
        "2 columns": "2 columns",
        'Auto-checking': 'Auto-checking',
        'Edit user': 'Edit user',
        "Select language": "Select language",
        "Admin": "Admin",
        "Train your first model with differents approachs, document entities or classification task faster.": "Train your first model with differents approachs, document entities or classification task faster.",
        "Create your first model": "Create your first model",
        "No data found": "No data found",
        "Apply request": "Apply request",
        "Generate your dataset from projects labelling or scenes": "Generate your dataset from projects labelling or scenes",
        "Generate your first dataset": "Generate your first dataset",
        "Prepare your raw datastore images for your future projects labelling on detection or classification task": "Prepare your raw datastore images for your future projects labelling on detection or classification task",
        "Create your first preset": "Create your first preset",
        "Start labelling or generate synthetic data from from your presets data store": "Start labelling or generate synthetic data from from your presets data store",
        "Create your first project": "Create your first project",
        "Deploy your first inference API on production with models": "Deploy your first inference API on production with models",
        "Deploy your first inference": "Deploy your first inference",
        "add first testing for your model, document entities or classification task faster.": "add first testing for your model, document entities or classification task faster.",
        "Create your first Testing": "Create your first Testing",
        'User edited!': 'User edited!',
        "French": "French",
        "English": "English",
        "Next: Capacity Machine": "Next: Capacity Machine",
        "Prev: Model": "Prev: Model",
        'Step 1. Model': 'Step 1. Model',
        'Step 2. Capacity Machine': 'Step 2. Capacity Machine',
        'Capacity Machine': 'Capacity Machine',
        'Bank': 'Bank',
        'KYC': 'KYC',
        'Other': 'Other',
        'Tax': 'Tax',
        'public-Inference': 'public-Inference',
        'Inferences model': 'Inferences model',
        'Pre-trained model': 'Pre-trained model',
        'heatmaps': 'heatmaps',
        'Request item': 'Request item',
        'Comparison metrics': 'Comparison metrics',
        'Comparison confusion matrix': 'Comparison confusion matrix',
        'Edit company': 'Edit company',
        'Edit inference': 'Edit inference',
        'admin': 'admin',
        'Edit inference account': 'Edit inference account',
        'web-view': 'web-view',
        'Document processed': 'Document processed',
        "columns": "columns",
        'Total': 'Total',
        'In use:': 'In use:',
        'Last use:': 'Last use:',
        'analytics': 'analytics',
        "Images not labeled": "Images not labeled",
        "Images skipped": "Images skipped",
        "images skipped": "images skipped",
        "not images labeled(s)": "not images labeled(s)",
        "images labelled": "images labelled",
        "STARTED": "STARTED",
        "FINISHED": "FINISHED",
        "QUEUED": "QUEUED",
        "PROCESSED": "PROCESSED",
        "FAILED": "FAILED",
        "CANCELED": "CANCELED",
        "AUTH-000": "To validate your account, please follow the confirmation link that we sent to the email address associated with your account. If you did not receive this link, please check your spam folder.",
        "FAILED SYSTEM": "FAILED SYSTEM",
        "DOING": "DOING",
        "running": "RUNNING",
        "Compte validé!": "Account validate",
        "Validation de votre compte": "Account validation",
        "SUBMITTED": "SUBMITTED",
        "Submitted": "Submitted",
        "codevalidate": "Congratulations, your account has been successfully validated! You will be redirected to the login page in 5 seconds.",
        "codevalidate no validate": "Sorry, your account could not be validated. Please contact the administrator for more information.",
        "receiveslacknotif": "Receive a notification on a Slack #channel after the end of each data processing",
        "UPLOADED": "UPLOADED",
        "Labeled(s)": "Labeled(s)",
        "Not Labeled(s)": "Not Labeled(s)",
        "Slack notification link": "Slack notification webhook link",
        "pleasenotusegmail": "Please use a professional email address to create an account.",
        "Skip Labeled(s)": "Skip Labeled(s)",
        'Unlimited': 'Unlimited',
        'Pre-trained': 'Pre-trained',
        'General': 'General',
        '5 days': '5 days',
        '2 weeks': '2 weeks',
        '1 year': '1 year',
        '15 minutes': '15 minutes',
        'Rename': 'Rename',
        'Skip': 'Skip',
        'general': 'general',
        "pretrained": "pretrained",
        'Financial': 'Financial',
        "Not available": "Not available",
        ' checkpoint(s)': ' checkpoint(s)',
        "Naming": "Naming",
        "Allow items": "Allow items",
        "Dataset imported (101)": "Dataset imported (101)",
        "Yes": "Yes",
        'No': 'No',
        'favorite': 'favorite',
        'If you create project labelling with create snap of preset you are sure to continue ?': 'If you create project labelling with create snap of preset you are sure to continue ?',
        'display': 'display',
        'Confirmation': 'Confirmation',
        'Back': 'Back',
        'key is required*': 'key is required*',
        'value is required*': 'value is required*',
        "Key": "Key",
        'Upload': 'Upload',
        'Trigger immediality model training when dataset finished with simple configuration.': 'Trigger immediality model training when dataset finished with simple configuration.',
        'Step 6. Pre configuration': 'Step 6. Pre configuration',
        'Preconfig': 'Preconfig',
        'Step 9. Preview': 'Step 9. Preview',
        "Request API": "Request API",
        "Display Name French": "Display Name French",
        "Description French": "Description French",
        "Reporting": "Reporting",
        "Visualization": "Visualization",
        'Cancel upload': 'Cancel upload',
        'Uploading...': 'Uploading...',
        'Files were uploaded successfully': 'Files were uploaded successfully',
        'PDF files splited': 'PDF files splited',
        'Files are not supported': 'Files are not supported',
        'Files were not uploaded': 'Files were not uploaded',
        'Files are saved': 'Files are saved',
        'Files are removed': 'Files are removed',
        "Information": "Information",
        '🤖 Documents does not exist because this request is failed': '🤖 Documents does not exist because this request is failed',
        "+ Add new Tag": "+ Add new Tag",
        'Pre configuration': 'Pre configuration',
        '7 hours': '7 hours',
        "Next: Description": 'Next: Description',
        'Features': 'Features',
        'Step 3.': 'Step 3.',
        'Enter Your Description': 'Enter Your Description',
        'Next: Class': 'Next: Class',
        'Prev: Class': 'Prev: Class',
        'Threshold must be between 0 to 100': 'Threshold must be between 0 to 100',
        '*Adding an testing name is a required field.': '*Adding an testing name is a required field.',
        'limitation': 'limitation',
        'Step 6. Dashboard configuration': 'Step 6. Dashboard configuration',
        'Step 7. Testing': 'Step 7. Testing',
        'Step 8. Capacity management': 'Step 8. Capacity management',
        "requests in last 30 days": "requests in last 30 days",
        "Models and inferences": "Models and inferences",
        "projects and datasets": "projects and datasets",
        "inferences": "inferences",
        "total models with": "total models with",
        "dataset": "dataset",
        "projects": "projects",
        "Show more...": "Show more...",
        "Show less": "Show less",
        "Request Number": "ID",
        "total projects with": "total projects with",
        "Deploy a flow API": "Deploy a flow API",
        "Add Flow": "Add Flow",
        "Add Comment": "Add Comment",
        "Validation": "Validation",
        "Success": "Success",
        "Error": "Error",
        "3. Flow": "3. Flow",
        "Warning": "Warning",
        "Step 3. Flow": "Step 3. Flow",
        "Validation Link": "Validation Link",
        "Flow Configuration.": "Flow Configuration.",
        "Node": "Node",
        "To Comment": "To Comment",
        "Update flow": "Update flow",
        "See on document": "See on document",
        "Relative Metrics": "Relative Metrics",
        "Absolute Metrics":"Absolute Metrics",
        "Absolute Accuracy":"Absolute Accuracy",
        "Relative Accuracy":"Relative Accuracy",
        "Average per image":"Average per image",
        "Average per field":"Average per field",
        "Average line":"Average line",
        "Not Verified": "Not Verified",
        "Verified": "Verified",
        "Average column":"Average column",
        "Merge":"Merge",
        "Validation Checked":"Validation Checked",
        "Checklists":"Checklists",
        "Activity":"Activity",
        "Data":"Data",
        "Priorities":"Priorities",
        "API and export":"API and export",
        "Inbound email":"Inbound email",
        "Add Priorities":"Add Priorities",
        "Add Checklists":"Add Checklists",
        "Select priority":"Select priority",
        "No checklist available":"No checklist available",
        "Dynamic Name": "Dynamic Name",
        "Change priority": "Change priority",
        "Not specified" : "Not specified",
        "Next: Documents": "Next: Documents",
        "Step 1. Path": "Step 1. Path",
        "Loading configuration": "Loading configuration",
        "Step 2. Documents": "Step 2. Documents",
        "Output type": "Output type",
        "No priority available": "No priority available",
        "Previous step": "Previous step",
        "Priority": "Priority",
        "Application": "Application",
        "Message":"Message",
        "Mark as see":"Mark as see",
        "Validation Node":"Validation Node",
        "Change category":"Change category",
        "Change state":"Change state",
        "Merge document":"Merge document",
        "Add document":"Add document",
        "Validations":"Validations",
        "Developers":"Developers",
        "Loan":"Loan",
        "Identity":"Identity",
        "No documents available":"No documents available",
        "Stats":"Stats",
        "Change Category":"Change Category",
        "Change Stats":"Change Stats",
        "Graph":"Graph",
        "Document Type":"Document Type",
        "Alerts":"Alerts",
        "Submit Pre request":"Submit Pre request",
        "Default life time for link":"Default life time for link",
        "select life time for link":"select life time for link",
        "January":"January",
        "February":"February",
        "March":"March",
        "April":"April",
        "May":"May",
        "June":"June",
        "July":"July",
        "August":"August",
        "September":"September",
        "October":"October",
        "November":"November",
        "December":"December",
        "Year":"Year",
        "Month":"Month",
        "Documents in":"Documents in",
        "Pages in":"Pages in"
}

export default message
/* eslint no-use-before-define: 2 */


// WEBPACK FOOTER //
// ./src/utils/translate-en.js